import Navbar from "../Components/NavbarItems/Navbar";
import Footer from "../Components/FooterItems/Footer";
import AboutShikha from "../Components/AboutShikha/AboutShikha";

function ShikhaAbout() {
  return (
    <>
      <Navbar />
      <AboutShikha />
      <Footer />
    </>
  );
}

export default ShikhaAbout;
